
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M0 23.77h40M2.5 24.2s1.88 12.57 6.05 12.57h22.9c4.17 0 6.05-12.57 6.05-12.57M9 36.58v3.19M31 36.58v3.19M17.41 4.88A5.88 5.88 0 006.09 7.1v16.18"}}),_c('path',{attrs:{"d":"M23.29 9.78a5 5 0 10-10 0z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"18.29","cy":"14.29","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"21.36","cy":"19.15","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"15.22","cy":"19.15","r":"1.5","fill":"#241f21"}})])
          )
        }
      }
    